import { render, staticRenderFns } from "./CategorieFSC.vue?vue&type=template&id=5f80e4d6"
import script from "./CategorieFSC.vue?vue&type=script&lang=js"
export * from "./CategorieFSC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports